import PropTypes from 'prop-types';
import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
// components
import LoadingScreen from '../components/loading-screen';
//
import Login from '../pages/auth/LoginPage';
import { useAuthContext } from './useAuthContext';
import { PATH_AUTH, USER_ROLE } from '../routes/paths';

// ----------------------------------------------------------------------
/**
 * Auth Guard for trainer
 */
AuthTrainerGuard.propTypes = {
  children: PropTypes.node,
};

export default function AuthTrainerGuard({ children }) {
  const { isAuthenticated, isInitialized, user } = useAuthContext();

  const location = useLocation();

  const [requestedLocation, setRequestedLocation] = useState(null);

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    if (location.pathname !== requestedLocation) {
      setRequestedLocation(location.pathname);
    }
    return <Login />;
  }

  return user?.role === USER_ROLE.trainer ||
    user?.role === USER_ROLE.assistantTrainer ||
    user?.role === USER_ROLE.jockey ? (
    <> {children} </>
  ) : (
    <Navigate to={PATH_AUTH.login} state={{ from: location }} replace />
  );
}
